module.exports = __webpack_public_path__ + "img/amx-22.89e17664.jpg";